import { computed, makeObservable, observable } from 'mobx';
import lessonManager from '../LessonManager';
import { LessonMode } from '../../../Constants';

export class UiFeedbackState {
  @observable
  submitButtonVisible = false;

  @observable
  submitButtonDisabled = false;

  @observable
  tryAgainButtonVisible = false;

  @observable
  loadingButtonVisible = false;

  @observable
  showAnswersButtonVisible = false;

  @observable
  showStudentAnswersButtonVisible = false;

  @observable
  hintButtonVisible = false;

  @observable
  solutionButtonVisible = false;

  @observable
  showAnswerFeedback = false; // the feedback for the student response (feedback icons or what ever shows student
  // correct or incorrect

  @observable
  showQuestionFeedback = false; // feedback at the bottom of questions

  @observable
  showFeedbackImages = false;

  @observable
  showAnswers = false; // list of expected answers at the bottom of questions or if the question component needs to show
  // the final correct answer some other way

  @computed
  get showFeedbackImagesNow() {
    return this.showFeedbackImages === true &&
      (lessonManager.playerMode === LessonMode.ACTIVITY_MODE ||
        lessonManager.playerMode === LessonMode.TEACHER_PRESENTATION ||
        lessonManager.playerMode === LessonMode.PREVIEW ||
        lessonManager.playerMode === LessonMode.PUBLISHER_PREVIEW);
  }

  @observable
  currentAttemptCount = 0;

  constructor() {
    makeObservable(this);
  }
}
